import type {SearchHistoryEntryDto} from 'typings/portaro.be.types';
import {unRestangularize} from 'shared/utils/data-service-utils';
import {ngAsync} from 'shared/utils/ng-@decorators';

/**
 * @ngdoc service
 * @name searchHistoryDataService
 * @module portaro.search
 *
 * @description
 * Data service for search history.
 */

export default class SearchHistoryDataService {
    public static serviceName = 'searchHistoryDataService';

    private static readonly SEARCH_HISTORY_ROUTE = 'search-history';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async getAll(sorting: string = '-date'): Promise<SearchHistoryEntryDto[]> {
        return this.Restangular
            .all(SearchHistoryDataService.SEARCH_HISTORY_ROUTE)
            .getList({sorting});
    }
}